import { forwardRef, type InputHTMLAttributes } from 'react';
import classnames from 'classnames';
import formStyles from '../../styles/form-control.module.scss';
import styles from './Textbox.module.scss';

type TextboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>;

export const Textbox = forwardRef<HTMLInputElement, TextboxProps>(function Textbox({ className, ...inputProps }, ref) {
  return <input ref={ref} className={classnames(formStyles.formControl, styles.input, className)} autoComplete="off" {...inputProps} />;
});
